export const USER_LOAD = 'USER_LOAD'
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS'
export const USER_LOAD_ERROR = 'USER_LOAD_ERROR'

export const USER_LOGOUT = 'USER_LOGOUT'

export const ME_LOAD = 'ME_LOAD'
export const ME_LOAD_SUCCESS = 'ME_LOAD_SUCCESS'
export const ME_LOAD_ERROR = 'ME_LOAD_ERROR'
